/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import 'react-toastify/dist/ReactToastify.css';

import CN from 'classnames';
import { Header } from 'components/common/Header';
import { SideBar } from 'components/common/SideBar';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { setUserDetails } from 'store/reducers/user/userSlice';

export interface MainLayoutProps {
  [x: string]: any;
}

export const MainLayout: FC<MainLayoutProps> = ({ children }: MainLayoutProps) => {
  const { userDetails }: any = useSelector<any>((state) => state.user);
  const { isLogOutModalOpen }: any = useSelector<any>((state) => state.user);
  const urlLocation = useLocation();
  const dispatch = useDispatch();
  const firstRoute = urlLocation.pathname.split('/')[1];
  const token = localStorage.getItem('token');

  useEffect(() => {
    dispatch(setUserDetails({ firstName: 'Super', lastName: 'Admin' }));
  }, [token, isLogOutModalOpen]);

  const initialObj = [
    {
      mainMenuId: 0,
      mainMenuItemKey: Math.random(),
      name: 'Dashboard',
      url: '/',
      icon: <i className="ri-line-chart-line" />,
      isSelected: false,
      hasSubmenu: false,
      isActive: true,
      subMenuItems: [],
    },
    {
      mainMenuId: 1,
      mainMenuItemKey: Math.random(),
      name: 'Content Creators',
      url: '/content-creators',
      icon: <i className="ri-file-list-2-line" />,
      isSelected: false,
      hasSubmenu: false,
      isActive: true,
      subMenuItems: [],
    },
    {
      mainMenuId: 2,
      mainMenuItemKey: Math.random(),
      name: 'Enterprises',
      url: '/enterprises',
      icon: <i className="ri-building-line" />,
      isSelected: false,
      hasSubmenu: false,
      isActive: true,
      subMenuItems: [],
    },
    {
      mainMenuId: 3,
      mainMenuItemKey: Math.random(),
      name: 'Videos',
      url: '/videos',
      icon: <i className="ri-video-on-line" />,
      isSelected: false,
      hasSubmenu: false,
      isActive: true,
      subMenuItems: [],
    },
    {
      mainMenuId: 4,
      mainMenuItemKey: Math.random(),
      name: 'Allocated Videos',
      url: '/allocated-videos',
      icon: <i className="ri-video-add-line" />,
      isSelected: false,
      hasSubmenu: false,
      isActive: true,
      subMenuItems: [],
    },
    {
      mainMenuId: 5,
      mainMenuItemKey: Math.random(),
      name: 'Categories',
      url: '/categories',
      icon: <i className="ri-shapes-line" />,
      isSelected: false,
      hasSubmenu: false,
      isActive: true,
      subMenuItems: [],
    },
  ];

  return (
    <div className="w-full h-screen">
      {/* <SideBar firstRoute={firstRoute} menuItemList={initialObj} userDetails={userDetails} /> */}

      <div
        className={CN(
          'main-layout__content z-10 fixed h-full left-0 w-full bg-[#f4f4f4]', // F9FAFB
        )}
      >
        <Header userDetails={userDetails} firstRoute={firstRoute} menuItemList={initialObj} />
        <div className="h-[calc(100%-70px)] w-full">
          {children}{' '}
          <ToastContainer
            position="bottom-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
            className="toast-container"
          />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
